<template>
  <div v-if="apiUser">
    <div class="layout__box__header layout__box__header--large-padding flex-wrap">
      <div class="w-100">
        <div class="d-flex justify-content-between align-items-top mb-2 flex-wrap admin-page__box__header">
          <h3 class="mt-1">
            {{ $t("zakaznikNadpis") }}
          </h3>
          <div
            class="btn btn-sm btn-primary d-flex align-items-center justify-content-center disabled"
            @click="newErrorVisible = true"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/ico-ico-plus-white.svg" />
            </div>
            {{ $t("novyZakaznik") }}
          </div>
          <div class="w-100 admin-page__box__select">
            <div v-if="customer && customers">
              <CustomSelect
                v-if="customers.length > 1"
                :items="customers"
                :medium="true"
                :name="'customerName'"
                :selected-item="customer"
                @select-item="setCustomerWithAutoProject"
              />
              <div v-else class="font-weight-light mt-2 mb-1">
                {{ customer.customerName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout__box__content admin-page__box__list">
      <a :href="mojeCRALink" class="admin-page__box__link w-100 d-flex link-no-style" target="_blank">
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-zakaznik.svg" />
          </div>
          <span class="font-weight-light d-flex align-items-center">
            {{ $t("informaceOZakaznikovi") }}
            <img class="admin-page__box__link__icon" src="@/assets/icons/admin/external-link.svg" />
          </span>
        </div>
      </a>
      <RouterLink
        :class="{ disabledClick: !apiUser.isCustomerAdmin }"
        :to="{
          name: 'adminCustomerServicesLimits'
        }"
        class="admin-page__box__link w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-sluzba.svg" />
          </div>
          <span class="font-weight-light">{{ $t("sluzbyALimity") }}</span>
        </div>
      </RouterLink>
      <RouterLink
        :class="{ disabledClick: !apiUser.isCustomerAdmin }"
        :to="{
          name: 'adminCustomerUsers'
        }"
        class="admin-page__box__link w-100 d-flex link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-sprava-uzivatelu.svg" />
          </div>
          <span class="font-weight-light">{{ $t("spravaUzivatelu") }}</span>
        </div>
      </RouterLink>
      <RouterLink
        :class="{ disabledClick: !apiUser.isCustomerAdmin }"
        :to="{
          name: 'adminCustomerUsersNotifications'
        }"
        class="admin-page__box__link w-100 d-flex link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-sprava-uzivatelu.svg" />
          </div>
          <span class="font-weight-light">{{ $t("spravaNotifikaci") }}</span>
        </div>
      </RouterLink>
      <div
        :class="{ disabledClick: !apiUser.isCustomerAdmin }"
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-tag-gray.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("spravaTaguAParametru") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        :class="{ disabledClick: !apiUser.isCustomerAdmin }"
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-zmenitsluzbu-disabled.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("workflowManazer") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        :class="{ disabledClick: !apiUser.isCustomerAdmin }"
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-zmenitsluzbu-disabled.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("payloadManazer") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <RouterLink
        :class="{ disabledClick: !apiUser.isCustomerAdmin }"
        :to="{ name: 'adminCustomerLogs' }"
        class="admin-page__box__link w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-log-operaci.svg" />
          </div>
          <span class="font-weight-light">{{ $t("logOperaci") }}</span>
        </div>
      </RouterLink>
      <RouterLink
        :class="{ disabledClick: !apiUser.isCustomerAdmin }"
        :to="{
          name: 'adminCustomerProjects'
        }"
        class="admin-page__box__link w-100 d-flex link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-prehled-projektu.svg" />
          </div>
          <span class="font-weight-light">{{ $t("prehledVsechProjektu") }}</span>
        </div>
      </RouterLink>
    </div>
    <div v-if="newErrorVisible">
      <ErrorModal :centered="true" :opened="true" @close="newErrorVisible = false" />
    </div>
  </div>
</template>

<script>
import Select from "@/components/inputs/select.vue"
import ErrorModal from "@/components/confirmations/contactManager.vue"
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    CustomSelect: Select,
    ErrorModal
  },
  props: {},
  setup() {
    const projectStore = useProjectStore()
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()
    const configStore = useConfigStore()

    return { projectStore, customerStore, authStore, configStore }
  },
  data() {
    return {
      newErrorVisible: false,
      autoSetProject: false,
      mojeCRALink: process.env.VUE_APP_USERINFO
    }
  },
  computed: {
    customer() {
      return this.customerStore.selectedCustomer
    },
    customers() {
      return this.customerStore.customerList
    },
    project() {
      return this.projectStore.selectedProject
    },
    projects() {
      return this.projectStore.projectList
    },
    customersProjects() {
      if (this.projects.filter((p) => p.customerId === this.customer.customerId).length > 0) {
        return this.projects.filter((p) => p.customerId === this.customer.customerId)
      } else {
        return []
      }
    },
    user() {
      return this.authStore.user
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  watch: {
    async customer() {
      await this.projectStore.getProjectList()
      if (this.customersProjects.length > 0) {
        if (this.autoSetProject) {
          this.projectStore.setProject(this.customersProjects[0])
          this.autoSetProject = false
        }
        this.configStore.setNoProjectVisible({
          noProjectVisible: false,
          noProjectVisiblePageInfo: false
        })
      } else {
        this.projectStore.setProject(null)
        this.configStore.setNoProjectVisible({
          noProjectVisible: true,
          noProjectVisiblePageInfo: true
        })
      }
    }
  },
  mounted() {},
  methods: {
    setCustomerWithAutoProject(customer) {
      this.autoSetProject = true
      this.customerStore.setCustomer(customer)
    },
    setCustomer(customer) {
      this.customerStore.setCustomer(customer)
    },
    toggleEditNotificationsModal(box) {
      if (this.openedEditNotificationsModal.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditNotificationsModal = [])
          : this.openedEditNotificationsModal.splice(this.openedEditNotificationsModal.indexOf(box), 1)
      } else {
        this.openedEditNotificationsModal.push(box)
      }
    }
  }
}
</script>
